import {
    Component,
    OnInit,
    ViewChild,
    Input,
    TemplateRef,
    Output,
    EventEmitter,
    OnDestroy
  } from '@angular/core';
  import { find } from 'lodash';
  import { FormGroup } from '@angular/forms';
  import {ChangeDetectorRef } from '@angular/core';

  // Servicios
  import { DocumentDependencyDataService } from './shared/document-dependency-data.service';
  import { DocumentDependencyFormService } from './shared/document-dependency-form.service';
  import { DocumentDependencyConfigService } from './shared/document-dependency-config.service';
  
  // Modelos
  import {
    TipoDocumentalPredeterminado,
    Const,
    PermisosTipoDocumental,
    SeriePredeterminada,
    SubSeriePredeterminada,
    DocumentoDependencia,
    Dependencia,
    Static
  } from '@app/shared';
  
  import { filter, findIndex } from 'lodash';
  import { LocalDataSource } from 'ng2-smart-table';
  import { BaseControl, ConfirmComponent } from '@app/shared';
  import { ToastrService } from 'ngx-toastr';
  import { Action } from '../documents.component';
  import { AuthenticationService } from '@app/core';
  import { Subject } from 'rxjs';
  import { ElementFinder } from 'protractor';
  
  type TypeFile = 'generacion' | 'vista_previa';
  
  @Component({
    selector: 'iw-document-dependency',
    templateUrl: './document-dependency.component.html',
    styleUrls: ['./document-dependency.component.scss'],
    providers: [
      DocumentDependencyDataService,
      DocumentDependencyFormService
    ]
  })
  export class DocumentDependencyComponent implements OnInit, OnDestroy {
  
    @Input() typeDocumentary: TipoDocumentalPredeterminado[]
    // Entrada de las series
    @Input() series: SeriePredeterminada[] = [];
    // Entrada de las subseries
    @Input() subseries: SubSeriePredeterminada[] = [];
    // Define la accion a realizar en el formulario
    actionForm = '';
    // Pregunta de la modal de confirmaciones
    question = '';
    // Define cuando mostrar el formulario
    formOpen = false;
    // Define cuando mostrar la tabla principal
    tableOpen = true;
    // Define el cargando de la tabla
    loadingPermissions = false;
    // Define si la valoracion en accion es para editar o agregar
    documentAssessmentEdit = true;
    // Contiene el registro seleccionado
    documentDependencySelect: DocumentoDependencia;
    // Referencia del formulario
    form: FormGroup;
    // Array de clasificaciones con filtro según el tipo de documento seleccionado
    arrayDocumentPermissionsFilter: LocalDataSource;
    // Configuracion de la tabla
    settings = {};
    // Define los tipos de permisos que tiene el usuario en sesión
    activateAction = {
      created: false,
      update: false,
      delete: false
    };
    // Tipos de documentos para el select
    typeDocumentaryList: TipoDocumentalPredeterminado[] = [];
    // Datos para llenar la tabla
    sourceData: PermisosTipoDocumental[] = [];
    // Contiene los controles de el formulario de asociaciones
    controls: BaseControl<any>[] = [];
    // Variable que valida los tipos de documentos que se pueden subir
    extensions: string[] = ['docx', 'doc'];
    // Lista de subseries a mostrar
    subseriesList: any[] = [];
    // Controla la serie seleccionada
    serieSelect: SeriePredeterminada;
    // controla el historial de la sede seleccionada
    serieSelectHistory: SeriePredeterminada;
    // Controla la subserie seleccionada
    subserieSelect: SeriePredeterminada;
    // Controla el historial de subserie seleccionada
    subserieSelectHistory: SeriePredeterminada;
    // Habilita el select de subserie
    subserie = false;
    // Habilita el select de tipo documental
    typeDoc = false;
    // Destruye y gestiona el memory leak
    private destroy: Subject<void> = new Subject<void>();
    // Referencia al componente de confirmación
    @ViewChild('confirm') private confirm: ConfirmComponent;
    // Referencia a la plantilla para el control personalizado de cargar documento
    @ViewChild('fileUpload') fileUpload: TemplateRef<any>;
    // Referencia a ala plantilla para el control de selector
    @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
    // Referencia al control de series
    @ViewChild("serieControl") serieControl: TemplateRef<any>;
    // Referencia al control de subseries
    @ViewChild("subserieControl") subserieControl: TemplateRef<any>;
    // Referencia al control de tipo documental
    @ViewChild("typeDocControl") typeDocControl: TemplateRef<any>;
    // id de la tipo de documento  seleccionada
    private _idTypeDocumentSelect: any;
    // controla el historial del tipo documental seleccionado
    private typeDocumentHistory: any;
    // row seleccionada
    selectRow: any;
    // id de la subserie seleccionada
    idSubSerieSelect: any;
    // Id del tipo documental seleccionado
    idTypeDocumentary: any;
    // listado de dependencias por estructura documental 
    documentDependency: DocumentoDependencia[];
    // lista de dependencias
    dependency: Dependencia[];
    // Entrada de las series internas
    Internalseries: SeriePredeterminada[] = [];
    // Entrada de las subseries internas
    private Internalsubseries: SubSeriePredeterminada[] = [];
  
  
    constructor(
      private cdref: ChangeDetectorRef,
      private dcds: DocumentDependencyDataService,
      private dcfs: DocumentDependencyFormService,
      private toastr: ToastrService,
      private as: AuthenticationService
    ) { }
  
    ngOnInit() {
      // Determina los permisos del usuario en sesion
      this.activateAction.created = this.as.confirmPermission(
        Const.types_permissions.administracionDependenciaDocumento,
        Const.types_action_permissions.created
      );
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administracionDependenciaDocumento,
        Const.types_action_permissions.update
      );
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administracionDependenciaDocumento,
        Const.types_action_permissions.delete
      );
      const configTable = new DocumentDependencyConfigService();
      this.settings = configTable.settings;
      configTable.accion.subscribe((res: any) => {
        switch (res.action) {
          default:
            this.defineActionCondictions(res.action, res.data);
            break;
        }
      });
      this.dcds.getDocumentDependency().subscribe(doc => this.documentDependency = doc)
      let company = this.dcds.idSelectCompany()
      this.dcds.getDependency(company).subscribe(dep => this.dependency = dep)
    }
  
    ngOnDestroy() {
      this.destroy.next();
      this.destroy.complete();
    }
  
    ngAfterContentChecked() {
      this.cdref.detectChanges();
    }

       
    set idTypeDocumentSelect(value: any) {
      if (value !== this.idTypeDocumentSelect) {
        this._idTypeDocumentSelect = value;
        // this.updateArrayFilter();
      }
    }
  
    get idTypeDocumentSelect(): any {
      return this._idTypeDocumentSelect;
    }
  
    /**
     * Cargando los tipos de documentales para el selector
     *
     * @memberof DocumentDependencyComponent
     */
    loadingTypeDocumentaryDocuments() {
      this.typeDocumentaryList = this.typeDocumentary;
      if (this.idTypeDocumentSelect) {
        const valid = findIndex(this.typeDocumentary, { 'id': this.idTypeDocumentSelect });
        if (valid === -1) {
          this.idTypeDocumentSelect = null;
        }
      }
    }
  
    /**
     * Define las acciones ha realizar
     *
     * @param {('add' | 'update' | 'delete')} [action='add']
     * @param {*} [data]
     * @memberof DocumentDependencyComponent
     */
    defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
      switch (action) {
        case 'add':
          if (this.activateAction.update) {
            this.formOpen = true;
            this.documentAssessmentEdit = true;
            this.actionForm = 'Agregar';
            this.documentDependencySelect = data;
            let info_doc: any = {};
            if(this.typeDocumentary){
              info_doc['tipo_documental'] =  this.typeDocumentary;
            }if(this.subseries){
              this.Internalsubseries = this.processOptions(this.subseries);
              info_doc['subserie'] = this.Internalsubseries
            } 
            if(this.series){
              this.Internalseries = this.processOptions(this.series);
              info_doc['serie'] = this.Internalseries;
            } 
            info_doc['dependencia'] = this.processOptions(this.dependency);
            this.controls = this.dcfs.getFormDocumentDependency({
            'select':this.ngSelectTpl,
            'serie':this.serieControl,
            'subserie':this.subserieControl,
            'tipo_documental':this.typeDocControl},data,info_doc);
          } else {
            this.toastr.warning('Usted no posee permisos para Agregar',
             'Permiso denegado');
          }
          break;
        case 'update':
          if (this.activateAction.update) {
            this.formOpen = true;
            this.documentAssessmentEdit = true;
            this.actionForm = 'Modificar';
            this.documentDependencySelect = data;
            let info_doc: any = {};
            if(this.typeDocumentary){
              info_doc['tipo_documental'] = this.typeDocumentary;
            }if(this.subseries){
              this.Internalsubseries = this.processOptions(this.subseries);
              info_doc['subserie'] = this.Internalsubseries
            } 
            if(this.series){
              this.Internalseries = this.processOptions(this.series);
              info_doc['serie'] = this.Internalseries;
            } 
            info_doc['dependencia'] = this.processOptions(this.dependency);
            // setea los valores para la serie, subserie y tipo documental en caso de que existan para la actualizacion
            this.formatSelectors((data.serie ? data.serie.id : null), (data.subserie ? data.subserie.id : null), (data.tipo_documental ? data.tipo_documental.id : null));
            this.controls = this.dcfs.getFormDocumentDependency({
              'select':this.ngSelectTpl,
              'serie':this.serieControl,
              'subserie':this.subserieControl,
              'tipo_documental':this.typeDocControl},data,info_doc);
          } else {
            this.toastr.warning('Usted no posee permisos para modificar',
             'Permiso denegado');
          }
          break;
        case "delete":
          if (this.activateAction.delete) {
            this.selectRow = data;
            this.question = "¿Realmente desea eliminar la valoración de documento?";
            this.confirm.open();
          } else {
            this.toastr.warning("Usted no posee permisos para eliminar valoración de documentos", "Permiso denegado");
          }
          break;
      }
    }
  
    /**
     * Cierra la vista del formulario de creacion o edicion de dependencia de documento
     *
     * @memberof DocumentDependencyComponent
     */
    closeFormDocumentAssessment() {
      this.actionForm = '';
      this.question = '';
      this.formOpen = false;
      this.documentAssessmentEdit = false;
      this.documentDependencySelect = null;
    }
  
    /**
     * Guarda o edita una dependencia de documento en el sistema
     *
     * @param {*} data
     * @memberof DocumentDependencyComponent
     */
    sended() {
      if (this.form.valid) {
        let resultData:any = {};
        resultData['serie'] = this.form.controls['serie'].value;
        resultData['subserie'] = this.form.controls['subserie'].value;
        // resultData['tipo_documental'] = this.form.controls['tipo_documental'].value;
        resultData['dependencia'] = this.form.controls['dependencia'].value;
        if (this.documentDependencySelect) {
          this.dcds.updateDocumentDependency(
            this.documentDependencySelect.id,
            resultData
          ).then(() => {
            this.closeFormDocumentAssessment();
            this.documentDependency.length = 0;
            this.dcds.getDocumentDependency().subscribe(doc => this.documentDependency = doc)
            
          });
        }else{
          this.dcds.addDocumentDependency(
            resultData
          ).then(() => {
            this.closeFormDocumentAssessment();
            this.documentDependency.length = 0;
            this.dcds.getDocumentDependency().subscribe(doc => this.documentDependency = doc)
          });
        }
      }
    }
  
    /**
     *Controla el cambio en la serie
     *
     * @param {*} obj
     * @memberof DocumentDependencyComponent
     */
     serieChange(obj: any) {
      if(obj === null){
        this.tableOpen = false;
        this.serieSelect = null;
        this.serieSelectHistory = null;
        this.subserie = false;
        this.typeDoc = false;
        this.subserieSelect = null;
        this.subserieSelectHistory = null;
        this.idTypeDocumentSelect = null;
        this.typeDocumentHistory = null;
        this.subseriesList.length = 0;
        this.subseriesList = [...this.subseriesList];
        this.typeDocumentaryList.length = 0;
        this.typeDocumentaryList = [...this.typeDocumentaryList];
        if(this.arrayDocumentPermissionsFilter){
          this.sourceData.length = 0;
          this.arrayDocumentPermissionsFilter.empty();
          this.arrayDocumentPermissionsFilter.refresh();
        }
      }else{
        this.subserie = true;
        this.typeDoc = false;
        this.subseriesList.length = 0;
        this.subseriesList = [...this.subseriesList];
        this.typeDocumentaryList.length = 0;
        this.typeDocumentaryList = [...this.typeDocumentaryList];
        this.Internalsubseries.forEach(subseries=>{
          if(subseries.serie.id == obj){
            this.subseriesList = [...this.subseriesList, subseries];
          }
        });
        if(this.serieSelect != this.serieSelectHistory && this.tableOpen){
          this.tableOpen=false;
          if(this.arrayDocumentPermissionsFilter){
            this.sourceData.length = 0;
            this.arrayDocumentPermissionsFilter.empty();
            this.arrayDocumentPermissionsFilter.refresh();
          }
        }
        this.serieSelect = obj;
        this.serieSelectHistory = obj;
        this.subserieSelect = null;
        this.subserieSelectHistory = null;
        this.idTypeDocumentSelect = null;
        this.typeDocumentHistory = null;
      }
    }
  
      /**
     *Controla el cambio en la subserie
     *
     * @param {*} obj
     * @memberof DocumentDependencyComponent
     */
     subserieChange(obj: any) {
      if(obj === null){
        this.tableOpen = false;
        this.typeDoc = false;
        this.subserieSelectHistory = null;
        this.idTypeDocumentSelect = null;
        this.typeDocumentHistory = null;
        if(this.arrayDocumentPermissionsFilter){
          this.sourceData.length = 0;
          this.arrayDocumentPermissionsFilter.empty();
          this.arrayDocumentPermissionsFilter.refresh();
        }
        this.typeDocumentaryList.length = 0;
        this.typeDocumentaryList = [...this.typeDocumentaryList];
      }else{
        this.typeDoc = true;
        this.idTypeDocumentSelect = null;
        this.typeDocumentaryList.length = 0;
        this.typeDocumentaryList = [...this.typeDocumentaryList];
        this.typeDocumentary.forEach(documentary =>{
          if(documentary.subserie.id == obj){
            this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
          }
        });
        if(this.tableOpen && this.subserieSelect != this.serieSelectHistory){
          this.tableOpen=false;
          if(this.arrayDocumentPermissionsFilter){
            this.sourceData.length = 0;
            this.arrayDocumentPermissionsFilter.empty();
            this.arrayDocumentPermissionsFilter.refresh();
          }
        }
        this.serieSelectHistory = obj;
        this.idTypeDocumentSelect = null;
        this.typeDocumentHistory = null;
      }
    }
  
  
     /**
     *Controla el cambio en el tipo documental
     *
     * @param {*} obj
     * @memberof DocumentDependencyComponent
     */
     typeDocumentChange(obj: any) {
      if(obj === null){
        this.tableOpen = false;
        this.idTypeDocumentSelect = null;
        this.typeDocumentHistory = null;
        if(this.arrayDocumentPermissionsFilter){
          this.sourceData.length = 0;
          this.arrayDocumentPermissionsFilter.empty();
          this.arrayDocumentPermissionsFilter.refresh();
        }
      }else{
        if(this.tableOpen && this._idTypeDocumentSelect != this.typeDocumentHistory){
          this.tableOpen=false;
          if(this.arrayDocumentPermissionsFilter){
            this.sourceData.length = 0;
            this.arrayDocumentPermissionsFilter.empty();
            this.arrayDocumentPermissionsFilter.refresh();
          }
        }
        this.typeDocumentHistory = obj;
      }
    }
  
    actionComfirm(res: boolean) {
      if (res) {
        if (this.selectRow) {
          this.dcds.deleteDocumentDependency(this.selectRow.id).then(res=>{
            if(res){
            this.documentDependency.length = 0;
            this.dcds.getDocumentDependency().subscribe(doc => this.documentDependency = doc)
            }
          })
          this.selectRow = null;
        }
      }
  }

  /**
   *Obtiene los cambios en los selectores de serie, subserie y tipo documental
   *
   * @param {*} data
   * @param {string} type
   * @memberof DocumentDependencyComponent
   */
   changeForm(data: any, type: string) {
    if(type=="serie" && data !== undefined){
      this.subseriesList.length = 0
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.Internalsubseries.forEach(subseries =>{
        if(subseries.serie.id == data.id){
          this.subseriesList = [...this.subseriesList, subseries];
        }
      });
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }else if(type=="serie" && data == undefined) {
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }

    if(type=="subserie" && data !== undefined){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }else if(type=="subserie" && data == undefined) {
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
    }
  }
    /**
   *Método que llena los selectores cuando hay una edición
   *Solo funciona en este caso específico
   *
   * @param {number} idSerie
   * @param {number} [idSubserie]
   * @param {number} [idDocumentary]
   * @memberof DocumentDependencyComponent
   */
   formatSelectors(idSerie: number, idSubserie?: number, idDocumentary?: number){
    this.subseriesList.length = 0
    this.subseriesList = [...this.subseriesList];
    this.typeDocumentaryList.length = 0;
    this.typeDocumentaryList = [...this.typeDocumentaryList];
    this.Internalsubseries.forEach(subseries =>{
      if(subseries.serie.id == idSerie){
        this.subseriesList = [...this.subseriesList, subseries];
      }
    });
    if(idSubserie){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = idSubserie;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }else{
      this.idSubSerieSelect = null;
    }
    if(idDocumentary){
      this.idTypeDocumentary = idDocumentary;
    }else{
      this.idTypeDocumentary = null;
    }
  }
  

   /**
   * mapea el valor de los selectores para retornar los nombre con el codigo
   *
   * @param {data<any>} data
   * @returns {data<any>[]}
   * @memberof DocumentDependencyComponent
   */
    processOptions(data:any){
      let new_data:any = [];
      data.forEach((element: any) => {
        let temporal_element:any = Static.copyObjet(element);
        temporal_element.nombre = element.codigo + " - " + element.nombre; 
        new_data.push(temporal_element)
      });
      return new_data
    }
    
  }
  


// WEBPACK FOOTER //
// ./src/app/administration/documents/document-dependency/document-dependency.component.ts